import React, { useState, useEffect, useCallback } from 'react'
import PropTypes from 'prop-types'
import Sidebar from '../../layout/Sidebar'
import { connect } from 'react-redux';
import { logout, updateBusinessInfo, removeBrandLogo } from '../../../actions/auth';
import { useDropzone } from 'react-dropzone';
import { Link } from 'react-router-dom';

import Alert from '../../layout/Alert';

import { base_url } from '../../../actions/constants';


const BusinessInformation = ({ auth: { user }, updateBusinessInfo, removeBrandLogo }) => {


    const [editPassword, setEditPassword] = useState(true);
    const [uploadedImage, setUploadedImage] = useState(null);

    const onDrop = useCallback((acceptedFiles) => {
        // Do something with the uploaded files
        // Check if there's at least one accepted file
        if (acceptedFiles.length > 0) {
            const file = acceptedFiles[0];
            console.log(file);
            // Set the first accepted file as the uploaded image
            setUploadedImage(file);

        }
    }, []);


    const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop, multiple: false, accept: 'image/*', });

    const dropzoneStyles = {
        textAlign: 'center',
        cursor: 'pointer',
    };

    const [formData, setFormData] = useState({
        id: '',
        firstname: '',
        lastname: '',
        business_name: '',
        email: '',
        mobile: '',
        password: '',
        brand_logo: '',
    });


    const { id, firstname, lastname, business_name, email, mobile, password, brand_logo } = formData;


    useEffect(() => {

        setFormData({
            id: '',
            firstname: user && user.firstName,
            lastname: user && user.lastName,
            business_name: user && user.businessName,
            email: user && user.email,
            mobile: user && user.businessPhone,
            password: '***************',
            brand_logo: user && user.brand_logo
        });

        // setUploadedImage(user && user.brand_logo);

    }, [user]);

    // console.log(uploadedImage);

    const onChange = e => setFormData({ ...formData, [e.target.name]: e.target.value });
    const onSubmit = e => {
        e.preventDefault();
        const fName = firstname ? firstname : user.firstName;
        const lName = lastname ? lastname : user.lastName;
        const mob = mobile ? mobile : user.businessPhone
        const user_id = user && user.id;
        const formData1 = new FormData();
        formData1.append('brand_logo', uploadedImage);
        formData1.append('firstname', fName);
        formData1.append('lastname', lName);
        formData1.append('mobile', mob);

        !editPassword && formData1.append('password', password);
        console.log(formData1);

        updateBusinessInfo(user_id, formData1);
    }
    const onDelete = () => {
        const id = user && user.id;
        removeBrandLogo(id);
        setUploadedImage(null);

    };

    const handlePwdToggle = () => {
        setFormData({
            password: !editPassword ? '***************' : '',
            brand_logo: user && user.brand_logo
        });
        setEditPassword(!editPassword);
    };

    return (
        <>
            <div className='wrapper'>
                <Sidebar />
                <div className='servicePage p-4'>
                    <Alert />
                    <h2 className='mb-3'>Business Settings</h2>
                    <form className='form' onSubmit={e => onSubmit(e)}>
                        <div className='card mb-4'>
                            <div className="card-header mb-4">
                                <h5 className='px-2 py-3 fw-bold'>Business Information</h5>
                            </div>
                            <div className='p-4'>
                                <input type="hidden" className='form-control form-control-lg ' name="id" id='id' value={id} />
                                <div className="row mb-3 mb-md-5">
                                    <div className="col-md-6 col-12 mb-3 mb-md-0">
                                        <label htmlFor='firstname' className="form-label">First Name</label>
                                        <input type="text" className="form-control form-control-lg" name='firstname' id='firstname' value={firstname} onChange={e => onChange(e)
                                        } required />
                                    </div>
                                    <div className="col-md-6 col-12">
                                        <label htmlFor='lastname' className="form-label">Last Name</label>
                                        <input type="text" className="form-control form-control-lg" name='lastname' id='lastname' value={lastname} onChange={e => onChange(e)
                                        } required />
                                    </div>
                                </div>
                                <div className='mb-3 mb-md-5'>
                                    <label htmlFor='business_name' className="form-label">Business Name</label>
                                    <input type="text" className='form-control form-control-lg' name="business_name" id='business_name' value={business_name} onChange={e => onChange(e)
                                    } required readOnly />
                                </div>
                                <div className="mb-3 mb-md-5">
                                    <label htmlFor="businessEmail" className="form-label">Business Email</label>
                                    <input type="email" className='form-control form-control-lg' name="email" id='businessEmail' value={email} onChange={e => onChange(e)
                                    } required readOnly />
                                </div>
                                <div className="row mb-3 mb-md-5">
                                    <div className="col-md-6 col-12 mb-3 mb-md-0 position-relative">
                                        <label htmlFor='password' className="form-label">Password</label>
                                        <input type='password' className="form-control form-control-lg" name="password" id='password' value={password} onChange={e => onChange(e)
                                        } aria-label="Password" required disabled={editPassword} />
                                        <div type="button" className="showpwd" onClick={handlePwdToggle} >
                                            Change Password
                                        </div>
                                    </div>
                                    <div className="col-md-6 col-12 mb-3 mb-md-0">
                                        <label className="form-label">Business Phone</label>
                                        <input type="text" className="form-control form-control-lg" name="mobile" value={mobile} onChange={e => onChange(e)
                                        } aria-label="Business mobile" />
                                    </div>

                                </div>

                            </div>

                        </div>
                        <div className='card '>
                            <div className="card-header">
                                <h5 className='px-2 py-3 fw-bold'>Business Branding</h5>
                            </div>
                            <p className='px-4 pt-4'>Business Logo (appears in online booking portal)</p>
                            <div className='d-flex align-items-center p-4' >
                                {uploadedImage ?
                                    (<div className='d-flex'>
                                        <img src={URL.createObjectURL(uploadedImage)} alt="Upload" className='align-self-center me-4' width="130px" />
                                        <div ></div>
                                    </div>) :
                                    brand_logo && (
                                        <div className='d-flex'>
                                            <img src={`${base_url}uploads/${brand_logo}`} alt="Uploaded" className='align-self-center me-4' width="130px" />
                                            <button onClick={() => onDelete()} className='btn btn-custom-ouline shadow-none align-self-center me-4'>Delete</button>
                                        </div>
                                    )
                                }
                                <div {...getRootProps()} style={dropzoneStyles}>
                                    <input {...getInputProps()} accept="image/*" />
                                    {isDragActive ? (
                                        <p>Drop the files here ...</p>
                                    ) : (
                                        <p>Drag 'n' drop some image here, or click to select image</p>
                                    )}
                                </div>
                            </div>

                        </div>
                        <div className='d-flex justify-content-end mt-4'>
                            <Link to='/business-settings' className="btn btn-custom-ouline shadow-none me-4"  >Cancel</Link>
                            <input type="submit" className="btn btn-custom" value="Save" />
                        </div>
                    </form>
                </div>
            </div>
        </>
    )
}

BusinessInformation.propTypes = {
    logout: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired,
    updateBusinessInfo: PropTypes.func.isRequired,
    removeBrandLogo: PropTypes.func.isRequired,
}

const mapStateToProps = state => ({
    auth: state.auth,

});

export default connect(mapStateToProps, { updateBusinessInfo, removeBrandLogo, logout })(BusinessInformation)
